module.exports = __webpack_public_path__ + "static/assets/2fb4b430169c3f5148703e29bfde1ef4.gif";